import styled from 'styled-components'
import LuxPlusExperienceDiscountTakeoverBackground from 'takeovers/luxplusExperienceDiscountTakeover/components/LuxPlusExperienceDiscountTakeoverBackground'
import { useShowExperienceDiscountBanner } from 'takeovers/luxplusExperienceDiscountTakeover/hooks/useShowExperienceDiscountBanner'
import useDoublePointsCampaignTier from '../hooks/useDoublePointsCampaignTier'

const Background = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;

  &.bronze {
    background: ${props => props.theme.palette.product.loyalty.bronze.gradientPrimaryBackground};
    color: ${props => props.theme.palette.product.loyalty.bronze.darkContrast};
  }

  &.silver {
    background: ${props => props.theme.palette.product.loyalty.silver.gradientPrimaryBackground};
    color: ${props => props.theme.palette.product.loyalty.silver.darkContrast};
  }

  &.gold {
    background: ${props => props.theme.palette.product.loyalty.gold.gradientPrimaryBackground};
    color: ${props => props.theme.palette.product.loyalty.gold.darkContrast};
  }

  &.platinum {
    background: ${props => props.theme.palette.product.loyalty.platinum.gradientPrimaryBackground};
    color: ${props => props.theme.palette.product.loyalty.platinum.lightContrast};
  }
`

const Container = styled.div`
  width: 100%;
  height: 100%;
`

interface Props {
  className?: string
  placement?: App.SiteTakeoverPlacement
}

function DoublePointTakeoverBackground(props: Props) {
  const { className, placement } = props
  const displayTier = useDoublePointsCampaignTier()
  const shouldShowExperienceDiscountBanner = useShowExperienceDiscountBanner()

  // Use LuxPlus background for site-wide banner in experience-enabled regions until Jan 5, 2026
  if (placement === 'siteWideBanner' && shouldShowExperienceDiscountBanner) {
    return <LuxPlusExperienceDiscountTakeoverBackground className={className} />
  }

  return <Container className={className}>
    <Background className={displayTier}>
    </Background>
  </Container>
}

export default DoublePointTakeoverBackground
